import { ElLoading } from "element-plus";
let loader;
export default {
    // start fetching
    axiosStart(state) {
        state.loading = true;
        loader = ElLoading.service({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
    },
    //fetching success
    axiosSuccess(state) {
        state.loading = false;
        loader.close();
    },
    //fetching error
    axiosError(state, err) {
        state.loading = false;
        loader.close();
        state.error = err;
    },
};
